/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';
import classnames from 'classnames';
import Card from 'components/card';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const Content = ({ children, className, ...rest }) => {
    const classes = classnames('annotated-section__content', className);
    return (
        <Box className={classes} {...rest}>
            {children}
        </Box>
    );
};

export default Content;
